import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ActiveKeysService = {
    list: () => axios.get(API_URL + "/activekeys/data").then(({ data }) => data).catch((err) => { throw err}),
}

export default ActiveKeysService;